export default __webpack_public_path__ + "img/3477a7c970f209e0504c2e67ebb012ba.svg";